<template>
<div ref="RecordDetail">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">记录详情</span>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回记录管理</el-button>
        </div>
    </div>
    
    <div class="TTL-table-custom">
        <table>
            <tr>
                <th>【类型 \ 记录宠物】</th>
                <td align="center">
                    <wcimage :value="recordinfos.typeicon" :option="{size:'middle'}" />
                    <span class="TTL-table-image-name">【{{recordinfos.record_type_parentname+'-'+recordinfos.record_type_name}}】</span>
                </td>
                <td align="center">
                    <wcimage :value="recordinfos.petavar" :option="{size:'middle'}" />
                    <span class="TTL-table-image-name">【{{recordinfos.petname}}】</span>
                </td>
            </tr>
            <tr>
                <th>【类型项目】</th>
                <td colspan="3">
                    <div class="program" v-for="(item,index) in details" :key="index">{{item}}</div>
                </td>
            </tr>
            <tr>
                <th>【记录时间】</th>
                <td colspan="3">{{recordinfos.recordtime}}</td>
            </tr>
            <tr>
                <th>【发布时间】</th>
                <td colspan="3">{{recordinfos.inputtime}}</td>
            </tr>
            <tr>
                <th>【描述】</th>
                <td colspan="3">{{recordinfos.content}}</td>
            </tr>
            <tr>
                <th>【上传文件】</th>
                <td colspan="3">
                    <el-image 
                        v-for="(item,index) in files" 
                        :key="index" 
                        :src="item.url ? item.url : require('@/assets/icon/pet-gray.png')" 
                        :preview-src-list="baseFiles"
                        fit="cover" 
                        class="file"
                    />
                </td>
            </tr>
            
        </table>
    </div>

</div>
</template>

<script>
import INTERFACE_MODEL_RECORD from '@/Interface/Record/Record';
export default {
    components:{},
    data() {
        return {
            recordinfos:{},
            details:[],
            files:[],
            baseFiles:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前已有记录信息正在查看，执行此操作会覆盖当前数据，是否执行 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetRecordDetails(data.id);
                }).catch(()=> {
                    
                });
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.ParseDataFromBrowser();
            }else {
                this.GetRecordDetails(data.id);
            }
        },


        /** 获取记录详情 **/
        GetRecordDetails(id) {
            var loadingobj=this.$refs.RecordDetail;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_RECORD.GET_RECORD_DETAIL({id:id}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                var result=res.data;
                this.recordinfos=result.records;
                this.details=result.detail;
                this.files=result.file;

                this.baseFiles=[];
                for(var i=0;i < this.files.length;i++) 
                this.baseFiles.push(this.files[i].baseurl);
            });
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'宠物记录',labelentry:'Record',components:'Record',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;margin:0 20px 0 0;position: relative;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-image-del {
    position: absolute;
    top:0;
    right:0;
    margin-top:-12.5px;
    margin-right:-12.5px;
    width:25px;
    height:25px;
    border-radius:50%;
    z-index:1;
    background-image: url(@/assets/icon/close-blue.png);
    background-repeat: no-repeat;
    background-size: 25px;
    background-position: center;
}
.TTL-image-box-middle .el-image {width:80px;height:80px;border-radius:50%;margin-left:20px;}
.TTL-image-box-small {width:65px;height: 65px;border-radius: 50%;}
</style>